const DataMenu = [
  {
    href: '/',
    text: 'Home',
  },
  {
    href: '#about',
    text: 'Sobre',
  },
  {
    href: '#projects',
    text: 'Projetos',
  },
  {
    href: '#contact',
    text: 'Contato',
  },
];

export default DataMenu;
